const CODE_TO_KEY = {
  FILE_TOO_LARGE: 'idpPage.errors.fileTooLarge',
  INVALID_EXPECTED_CLASSES_JSON: 'idpPage.errors.invalidExpectedClassesJson',
  INVALID_OPTIONS_JSON: 'idpPage.errors.invalidOptionsJson',
  INVALID_FORM_JSON: 'idpPage.errors.invalidFormJson',
  INVALID_REQUEST_BODY: 'idpPage.errors.invalidRequestBody',
  INVALID_FORM_METADATA: 'idpPage.errors.invalidFormMetadata',
  INTERNAL_ERROR: 'idpPage.errors.internalError',
};

/**
 * Maps API error JSON (`errors[0].code`) to a localized UI message, or null.
 * @param {string} responseBody
 * @param {(key: string) => string} t
 */
export function messageFromStructuredApiError(responseBody, t) {
  try {
    const j = JSON.parse(responseBody);
    const envelopeMessage = j.error?.message;
    if (typeof envelopeMessage === 'string') {
      if (/not configured/i.test(envelopeMessage)) {
        return t('idpPage.errors.serviceNotConfigured');
      }
      if (/service unavailable|unavailable/i.test(envelopeMessage)) {
        return t('idpPage.errors.serviceUnavailable');
      }
    }
    const code = j.errors?.[0]?.code;
    const key = code ? CODE_TO_KEY[code] : null;
    if (key) {
      return t(key);
    }
  } catch {
    /* ignore */
  }
  return null;
}

/**
 * Extracts `correlation_id` from a Hub360 error envelope body, or null.
 * Used as a fallback when the service layer did not surface it.
 * @param {string} responseBody
 * @returns {string|null}
 */
export function correlationIdFromResponseBody(responseBody) {
  if (typeof responseBody !== 'string' || !responseBody) return null;
  try {
    const j = JSON.parse(responseBody);
    const id = j?.correlation_id;
    return typeof id === 'string' && id.trim() ? id.trim() : null;
  } catch {
    return null;
  }
}
